'use strict';

var App = require('app');
var ProfileController = require('components/profile/profile_controller');
var Strings = require('utils/strings');

var ProfileComponent = {};

ProfileComponent.initializeRouting = function () {
    new ProfileComponent.Router({
        controller: API,
    });
};

ProfileComponent.Router = App.BaseRouter.extend({
    appRoutes: {
        'profile/access-admins': 'AdminUser',
        'profile/access-api-config': 'ApiConfigurationView',
        'profile/access-device-groups': 'DeviceGroups',
        'profile/access-mailboxes': 'MailboxListView',
        'profile/access-user-groups': 'UserGroups',
        'profile/api': 'ApiDocumentationView',
        'profile/billing': 'BillingView',
        'profile/changed': 'Changed',
        'profile/report-communication': 'GatewayReportView',
        'profile/report-devices(/:id)': 'DeviceReportView',
        'profile/settings': 'SettingsView',
        'profile/webhooks': 'WebhookView',
        'profile/label-pool': 'LabelPool',
    },
});

var API = {
    BillingView: function () {
        ProfileController.BillingView();
    },
    SettingsView: function () {
        ProfileController.Settings();
    },
    SettingsDialog: function (params) {
        ProfileController.SettingsDialog(params);
    },
    DeviceReportView: function (id) {
        ProfileController.DeviceReportView(id);
    },
    GatewayReportView: function () {
        ProfileController.GatewayReportView();
    },
    Changed: function () {
        ProfileController.Settings(true);
    },
    AdminUser: function () {
        ProfileController.AdminUser();
    },
    DeviceGroups: function () {
        ProfileController.DeviceGroups(false);
    },
    UserGroups: function () {
        ProfileController.DeviceGroups(true);
    },
    MailboxListView: function () {
        ProfileController.MailboxListView();
    },
    ApiDocumentationView: function (api_key) {
        ProfileController.ApiDocumentationView(api_key);
    },
    ApiConfigurationView: function () {
        ProfileController.ApiConfigurationView();
    },
    WebhookView: function () {
        ProfileController.WebhookView();
    },
    LabelPool: function () {
        ProfileController.LabelPool();
    },
};

App.on('profile:reports:device', function (id) {
    App.navigate(Strings.joinURL('profile/report-devices', id));
    API.DeviceReportView(id);
});

App.on('profile:show:billing', function () {
    API.BillingView();
});

App.on('profile:show:settings', function () {
    API.SettingsView();
});

App.on('profile:settings', function (params) {
    API.SettingsDialog(params);
});

App.on('profile:users-admin', function () {
    API.AdminUser();
});

App.on('profile:groups', function () {
    API.DeviceGroups();
});

App.on('profile:email', function () {
    API.MailboxListView();
});

App.on('profile:api-spec', function (api_key) {
    App.navigate('profile/api', true);
    API.ApiDocumentationView(api_key);
});

App.on('profile:api-config', function () {
    API.ApiConfigurationView();
});

module.exports = ProfileComponent;
